define('views/modules/conversation/message/message-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/conversation/conversation',
    'collections/member/supervisors',
    // views
    'views/parts/list/fetch-list',
    'views/modules/conversation/message/message-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    //models
    MConversation,
    Supervisors,
    // views
    VFetchList,
    VMessageListItem
) {

    var VMessageList = VFetchList.extend({
        item: VMessageListItem,

        initialize: function(opt) {
            VMessageList.__super__.initialize.apply(this, arguments);
            this.conversation = opt.conversation;
            this.listenTo(Supervisors, 'sync', this.render);
        },

        render: function() {
            VMessageList.__super__.render.apply(this, arguments);
            if (this.options.async) {
                this._updateMoreButton();
            }

            return this;
        },

        getItemOptions: function(options) {
            return _.extend(options, {
                supervisors: Supervisors
            }, _.pick(this.options, ['conversation', 'role', 'url', 'group', 'profile', 'filter']));
        },

        _updateMoreButton: function() {
            this.view.more.toggle(this.hasLeft());
        },

        hasLeft: function() {
            if (!this.conversation) return false;
            if (this.collection.length === 0) return false;
            return this.conversation.get('totalMessages') - this.collection.length > 0;

        },

        onLoadMore: function(e, callback) {
            var pageHeight = document.getElementById("page").scrollHeight;
            this.conversation.queryParams.limit = 10;

            this.conversation.fetch({
                silent: true,
                messagesCount: this.collection.length,
                context: this,
                success: function() {
                    this.view.more.finished();
                    this.collection.set(this.conversation.getMessages({ collection: true }).models, { remove: false, at: 0 });
                    this.collection.trigger('list:loadMoreCompleted', pageHeight);
                    this._updateMoreButton();
                },
            });
        },
    });

    return VMessageList;

});

